export const INVOICES_PAGE_SIZE = 50;

export function defaultInvoiceDateRange() {
  const today = new Date();
  const y = today.getFullYear();
  const m = String(today.getMonth() + 1).padStart(2, "0");
  const d = String(today.getDate()).padStart(2, "0");
  return {
    dateFrom: "2025-01-01",
    dateTo: `${y}-${m}-${d}`,
  };
}

export function formatInvoiceDate(isoDate) {
  if (!isoDate) {
    return "—";
  }
  const parts = String(isoDate).slice(0, 10).split("-");
  if (parts.length !== 3) {
    return "—";
  }
  const [year, month, day] = parts;
  if (!year || !month || !day) {
    return "—";
  }
  return `${day}.${month}.${year}`;
}

export function filterInvoicesBySearch(invoices, query) {
  const list = invoices ?? [];
  const q = (query ?? "").trim();
  if (q.length < 2) {
    return list;
  }
  const lower = q.toLowerCase();
  return list.filter((row) =>
    String(row.invoice_1c_field ?? "")
      .toLowerCase()
      .includes(lower),
  );
}

function compareDates(a, b, desc) {
  const ta = new Date(a).getTime();
  const tb = new Date(b).getTime();
  const va = Number.isNaN(ta) ? 0 : ta;
  const vb = Number.isNaN(tb) ? 0 : tb;
  return desc ? vb - va : va - vb;
}

function compareAmount(a, b, desc) {
  const na = Number.parseFloat(String(a ?? "0").replace(/\s/g, ""));
  const nb = Number.parseFloat(String(b ?? "0").replace(/\s/g, ""));
  const va = Number.isNaN(na) ? 0 : na;
  const vb = Number.isNaN(nb) ? 0 : nb;
  return desc ? vb - va : va - vb;
}

export function sortInvoices(invoices, { field, desc }) {
  const list = [...(invoices ?? [])];
  list.sort((left, right) => {
    if (field === "amount") {
      return compareAmount(left.amount, right.amount, desc);
    }
    if (field === "closedate") {
      return compareDates(left.closedate, right.closedate, desc);
    }
    return compareDates(left.begindate, right.begindate, desc);
  });
  return list;
}

export function formatQuantityWithMeasure(quantity, measureName) {
  const q = quantity ?? "—";
  const measure = measureName ? ` ${measureName}` : "";
  return `${q}${measure}`.trim();
}

export function displayTaxField(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  return String(value);
}
